import { createSlice } from "@reduxjs/toolkit";

const initialAuthState = { isAuthenticated: false, token: null, emailId: "" };

const authSlice = createSlice({
    name: "authentication",
    initialState: initialAuthState,
    reducers: {
        login(state, action) {
            state.isAuthenticated = true;
            state.token = action.payload.token;
            state.emailId = action.payload.emailId;
        },
        logout(state) {
            state.isAuthenticated = false;
            state.token = null;
            state.emailId = "";
        }
    }
})

export default authSlice;
